<div *ngIf="isCountryAllowed === 2">
  <app-quick-register [landing_page]="'lp-quick_register'"></app-quick-register>
</div>
<div *ngIf="isCountryAllowed === 1">
  <app-trustly-reg-step-one  [landing_page]="'lp-quick_register'" [callingFrom]= "'banner'"></app-trustly-reg-step-one>
</div>